(function () {
  function initCard(root) {
    const btn = root.querySelector('[data-ivg-toggle]');
    if (!btn) return;

    const mp4Video = root.querySelector('video.ivg__video');
    const iframe = root.querySelector('iframe.ivg__embed');
    const poster = root.querySelector('[data-ivg-poster]');
    const playIcon = btn.querySelector('.ivg__icon--play');
    const pauseIcon = btn.querySelector('.ivg__icon--pause');

    function setPlaying(isPlaying) {
      if (playIcon) playIcon.style.display = isPlaying ? 'none' : 'block';
      if (pauseIcon) pauseIcon.style.display = isPlaying ? 'block' : 'none';
    }

    // MP4 / Shopify video: real play/pause
    if (mp4Video) {
      setPlaying(!mp4Video.paused && !mp4Video.ended);

      mp4Video.addEventListener('play', () => setPlaying(true));
      mp4Video.addEventListener('pause', () => setPlaying(false));
      mp4Video.addEventListener('ended', () => setPlaying(false));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (mp4Video.paused) mp4Video.play();
        else mp4Video.pause();
      });

      return;
    }

    // YouTube/Vimeo iframe
    if (iframe) {
      setPlaying(false);

      function hidePoster() {
        if (poster) poster.classList.add('is-hidden');
      }

      // Click poster to play & hide it
      if (poster) {
        poster.addEventListener('click', function () {
          hidePoster();
          // Autoplay YouTube
          if (iframe.src.includes('youtube.com')) {
            var src = iframe.src;
            if (!src.includes('autoplay=1')) {
              src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
              iframe.src = src;
            }
          }
        });
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        hidePoster();
        iframe.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ivg-video]').forEach(initCard);
  });
})();
